/**
 * BaseTheme rework now uses javascript version ES6
 * ------
 *
 * Functions and Variables are no longer global and need to be imported
 * ( How to prepare function for export can be seen in `utils.js` )
 */
import { initUtils, easedScroll } from './utils';
//import { initSliders } from './glide'
import { initDropdowns } from './dropdowns';
import { initMenu } from "./menu";
import { initGoogleMap } from './map';
import { setupAnchorHolders } from './anchors';
import { initHeroParalax } from './paralax';
import { initFooterParalax } from './paralax';
import { initBodyParalax } from './paralax';
import { initFormFunctions } from './form';

import Swiper from 'swiper';
import { Navigation, Keyboard, A11y } from 'swiper/modules';

window.Swiper = Swiper
window.Navigation = Navigation
window.Keyboard = Keyboard
window.A11y = A11y



/**
 * This function or DOMContentLoaded event is necesary for compiling to work
 *
 * Standalone functions will be removed on compile, so function that is called only in onclick event for example will be removed
 */
window.onload = () => {
    initUtils()
    //initSliders()
    initMenu()
    initDropdowns()
    setupAnchorHolders()
    initGoogleMap()
    initFormFunctions();
    if (screen.width > 720) {


        initHeroParalax()
        initFooterParalax()
        initBodyParalax()
    }
}

